import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver } from 'react-hook-form';
import { CreateBotT, OneBotT, UpdateBotT, BotTypeT } from 'shared/api/types/bots';
import * as Yup from 'yup';
import initDefaultSchema from '../yupConfig';

initDefaultSchema();

const botTypes: BotTypeT[] = ['linkGenerate', 'inviteApprove', 'single'];

export const botTypeOptions = botTypes.map((type) => ({
  value: type,
  label: type,
}))

// Create Bot
export type CreateBotFormT = Omit<CreateBotT['request'], 'username'>;
export const getCreateBotValues = (): CreateBotFormT => ({
  type: null,
  name: '',
  token: '',
});
const createBotSchema: Yup.ObjectSchema<CreateBotFormT> = Yup.object({
  type: Yup.string().oneOf(botTypes).required(),
  name: Yup.string().nullable(),
  token: Yup.string().required(),
});
export const createBotResolver = yupResolver(createBotSchema) as Resolver<CreateBotFormT>;

// Update Bot
export type UpdateBotFormT = Omit<UpdateBotT['request'], 'username'>;
export const getUpdateBotValues = (values?: OneBotT['response']): UpdateBotFormT => ({
  type: values?.type ?? null,
  name: values?.name ?? '',
});
const updateBotSchema: Yup.ObjectSchema<UpdateBotFormT> = Yup.object({
  type: Yup.string().oneOf(botTypes).required(),
  name: Yup.string().nullable(),
});
export const updateBotResolver = yupResolver(updateBotSchema) as Resolver<UpdateBotFormT>;
